import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import AppearanceModifier from "./base/AppearanceModifier";
import BackgroundModifierComponent from "./base/BackgroundModifier";
import BorderModifier from "./base/BorderModifier";
import GapModifierComponent from "./base/GapModifier";
import MarginModifierComponent from "./base/MarginModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface ContainerModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    byteOffset: number,
  ) => void;
}

const ContainerModifierBlock: React.FC<ContainerModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Gap",
          component: (
            <GapModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
        {
          title: "Margin",
          component: (
            <MarginModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
        {
          title: "Background",
          component: (
            <BackgroundModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Border",
          component: (
            <BorderModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Appearance",
          component: (
            <AppearanceModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.byteOffset,
                );
              }}
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default ContainerModifierBlock;
